import { Outlet, Link, useLocation } from 'react-router-dom';

function Layout() {
  const location = useLocation();
  
  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <div className="layout">
      <header className="header">
        <div className="header-container">
          <Link to="/" className="logo">
            <span className="logo-icon">🐦</span>
            <span className="logo-text">Gukni Golube</span>
          </Link>
          
          <nav className="nav">
            <Link to="/" className={`nav-link ${isActive('/') && location.pathname === '/' ? 'active' : ''}`}>
              Početna
            </Link>
            <Link to="/clanci" className={`nav-link ${isActive('/clanci') || isActive('/clanak') ? 'active' : ''}`}>
              Članci
            </Link>
            <Link to="/kviz" className={`nav-link ${isActive('/kviz') ? 'active' : ''}`}>
              EI Kviz
            </Link>
          </nav>
        </div>
      </header>

      <main className="main">
        <Outlet />
      </main>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-brand">
            <span className="logo-icon">🐦</span>
            <span>Gukni Golube</span>
          </div>
          <p className="footer-tagline">Matematika ne laže. Populizam da.</p>
          <div className="footer-links">
            <Link to="/clanci">Članci</Link>
            <Link to="/kviz">EI Kviz</Link>
          </div>
          <p className="footer-copy">© 2025 Igor Grčman. Sva prava pridržana.</p>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
